import { render, staticRenderFns } from "./files-upload.vue?vue&type=template&id=6067d8b2&scoped=true&"
import script from "./files-upload.vue?vue&type=script&lang=js&"
export * from "./files-upload.vue?vue&type=script&lang=js&"
import style0 from "./files-upload.vue?vue&type=style&index=0&id=6067d8b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6067d8b2",
  null
  
)

export default component.exports